export default "/images/vendor/@coreui/icons/svg/flag/cif-td.svg?ba6de3a4cb9af2dfdf89769f721b071f";